import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';

import { InspireCardSkeletonTestId } from '../InspireGridSkeleton/constants';
import classes from './InnerSkeleton.module.scss';

interface InnerSkeletonProps {
  height: number;
}

export const InnerSkeleton = ({ height }: InnerSkeletonProps) => {
  return (
    <div className={classes.container} data-testid={InspireCardSkeletonTestId}>
      <Skeleton width="auto">
        <SkeletonSquare width="auto" height={height} />
      </Skeleton>
    </div>
  );
};
